const s3Url =
  "https://deskday-public.s3-accelerate.amazonaws.com/Frontend-images";

const teamSetup = `${s3Url}/teamSetup.webp`;
const companyProfile = `${s3Url}/companyProfile.png`;
const integrations = `${s3Url}/integrations.webp`;
const customers = `${s3Url}/customers.png`;
const sampleData = `${s3Url}/sampleData.webp`;
const channelsEmail = `${s3Url}/channelsEmail.webp`;
const channelsDesktop = `${s3Url}/channelsDesktop.webp`;
const channelsAndroid = `${s3Url}/channelsAndroid.webp`;
const channelsTeams = `${s3Url}/channelsTeams.webp`;
const channelsIos = `${s3Url}/channelsIos.webp`;
const readyBg = `${s3Url}/readyBg.png`;
const webPortal = `${s3Url}/channelsAgentWeb.webp`;

export const steps = [
  {
    key: "team",
    title: "How many teammates will be using DeskDay?",
    rightBg: teamSetup,
    estimatedTime: "4 Min",
  },
  {
    key: "company-profile",
    title: "Let's set up your company profile",
    rightBg: companyProfile,
    estimatedTime: "4 Min",
  },
  {
    key: "integrations",
    title: "Apps you work with",
    rightBg: integrations,
    estimatedTime: "2 Min",
  },
  {
    key: "customers",
    title: "Onboard your first customer",
    rightBg: customers,
    estimatedTime: "2 Min",
  },
  {
    key: "sample-data",
    title: "Get a head start with sample data",
    rightBg: sampleData,
    estimatedTime: "1 Min",
  },
  {
    key: "channels",
    title: "Support your customers anywhere",
    rightBg: {
      email: channelsEmail,
      desktop: channelsDesktop,
      mobile: channelsAndroid,
      webPortal: webPortal,
      // android: channelsAndroid,
      // ios: channelsIos,
      teams: channelsTeams,
    },
    estimatedTime: "0 Min",
  },
  {
    key: "ready",
    title: "Your DeskDay account is ready! 🚀",
    rightBg: readyBg,
    estimatedTime: "",
  },
  // {
  //   key: "billing-settings",
  //   title: "Configure billing settings",
  // },
  // {
  //   key: "ready",
  //   title: "Your DeskDay account is ready! 🚀",
  // },
];
